import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
//import PropTypes from 'prop-types';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
//import PropTypes from 'prop-types';
//import BoltIcon from '@mui/icons-material/Bolt';
import Swal from 'sweetalert2';
import { fetchConToken } from "helpers/fetch";


import BatteryCharging20Icon from '@mui/icons-material/BatteryCharging20';
import BatteryCharging30Icon from '@mui/icons-material/BatteryCharging30';
import BatteryCharging50Icon from '@mui/icons-material/BatteryCharging50';
import BatteryCharging60Icon from '@mui/icons-material/BatteryCharging60';
import BatteryCharging80Icon from '@mui/icons-material/BatteryCharging80';
import BatteryCharging90Icon from '@mui/icons-material/BatteryCharging90';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import BatteryUnknownIcon from '@mui/icons-material/BatteryUnknown';
import BatteryAlertIcon from '@mui/icons-material/BatteryAlert';

import { useSelector } from 'react-redux';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'
import classes from '../WeatherMain/WeatherMain.module.css';



const translations = {
  en: {
    labelSensor: "Sensor",
    labelId: "Id.",
    labelBattery: "Battery",
    labelBatPercent: "% Bat",
    labelState: "State",
    labelMetricas: "Metrics",
    labelNoMatch: "No sensors found",
    labelActive: "Active",
    labelInActive: "Inactive",
    labelError: "Error collecting metrics, cod. 0x0MSL1",
  },
  es: {
    labelSensor: "Sensor",
    labelId: "Id.",
    labelBattery: "Batería",
    labelBatPercent: "% Bat",
    labelState: "Estado",
    labelMetricas: "Metricas",
    labelNoMatch: "No se encontraron sensores",
    labelActive: "Activo",
    labelInActive: "Inactivo",
    labelError: "Error colectando metricas, cod. 0x0MSL1",
  }
};
  
    


const getMuiTheme = () => createTheme({
    overrides: {
        MuiTableHead: {
            root: {
                height: "5px",
                padding: '2px',
                fontSize:'8px'
            }
        },
        MUIDataTable: {
           
            paper: {
              boxShadow: 'none',
            },
          },
           MuiTableCell: {
            root: {  //This can be referred from Material UI API documentation. 
                padding: '4px',
                width: '50px',
                height: '30px',
                fontSize:'8px'
                //backgroundColor: "#eaeaea",
                
            }, 
        },
    }
  })

export default function SensorsTable(props) {
    
    const { start, sensors} = props;
    const [sensorMetrics, setSensorMetrics] = useState([]);
    const {language, allPlantaciones, indexPlantacion} = useSelector( state => state.data); 

    
    //console.log('languaje Sensorstable',language);
    const t = translations[language];

    const columns = [
        {
        name: "name",
        label: t.labelSensor,
        width: "20%",
        options: {
            setCellProps: () => ({ style: { minWidth: "70px", maxWidth: "70px", fontSize:'14px' }}),
            //customBodyRender: (data, type, row) => {return <pre>{data}</pre>}
        }, 
        },
        /* {
            name: "id",
            label: "Id.",
            width: "30%",
            options: {
            setCellProps: () => ({ style: { minWidth: "60px", maxWidth: "60px" }}),
            //customBodyRender: (data, type, row) => {return <pre>{data}</pre>}
            },
        }, */
        {
        name: "batery",
        label: t.labelBattery,
        width: "15%",
        /* options: {
            setCellProps: () => ({ style: { minWidth: "30px", maxWidth: "30px" }}),
            //customBodyRender: (data, type, row) => {return <pre>{data}</pre>}
        }, */
        
        },
        {
            name: "batery_per",
            label: t.labelBatPercent,
            width: "20%",
            options: {
                setCellProps: () => ({ style: { minWidth: "40px", maxWidth: "40px", fontSize:'14px' }}),
            //customBodyRender: (data, type, row) => {return <pre>{data}</pre>}
            }, 
            
        },
        {
            name: "state",
            label: t.labelState,
            width: "15%",
            options: {
                setCellProps: () => ({ style: { minWidth: "40px", maxWidth: "40px", fontSize:'14px' }}),
            //customBodyRender: (data, type, row) => {return <pre>{data}</pre>}
            }, 
            
        },
        /* {
            name: "capabilities",
            label: "Metricas",
            width: "10%",
            options: {
            setCellProps: () => ({ style: { minWidth: "30px", maxWidth: "60px" }}),
            //customBodyRender: (data, type, row) => {return <pre>{data}</pre>}
            },
            
        }, */
    ];



    const options = {
        filter: false,
        search: false,
        print: false,
        download: false,
        viewColumns: false,
        customToolbar: null,
        responsive: 'standard',
        selectableRowsHideCheckboxes: true,
        selectableRows: 'single',
        tableBodyHeight: 'auto',
        pagination: false,
        sort: false,
        textLabels: {
            body: {
            noMatch: t.labelNoMatch,
            }
        },
        setTableProps: () => {
            return {
            padding: 'normal',

            // material ui v4 only
            size: 'small',
            };
        }, 
        setCellProps: () => {
            return {
            style: { minWidth: "50px", maxWidth: "50px", fontSize:'8px', },
            };
        }, 
    };

    //console.log("sensors en datatable", sensors.toString());

    useEffect(() => {

        let mounted = true;
  
      //Query Influx for Sensors metrics
      const fetchMetrics = async () => {
        
          try {
            //const start ="-1h";
            //const measure="device_frmpayload_data_voltage";
            
            let sensorStr = "";
            sensors.map((row)=>{
                sensorStr += row.dev_eui+',';
            });
            sensorStr = sensorStr.slice(0, -1)
            
            //console.log("sensors en datatable", sensorStr);

            const resp2 = await fetchConToken( `data?start=`+start+`&query=battery_sensors&sensors=`+sensorStr)
            const body2 = await resp2.json();
            
            
            
            if( body2.ok ) {
                if(mounted) {
                  console.log("statuscode:" + body2.data);
                  setSensorMetrics(body2.data)
                }
            }else{
              Swal.fire('Error colectando metricas, cod. 0x0MSL1', "BD Conect", 'error');
            }
          } catch (error) {
            Swal.fire('Error colectando metricas, cod. 0x0MSL1', "BD Error", 'error');
          }
      }
  
  
  
        //fetchSensor();
        fetchMetrics();
        return () => mounted = false;
  
    }, [indexPlantacion, allPlantaciones])




    //console.log("metricas en SensorsTable ",sensorMetrics);

    const data = [];
    sensors.map((sensor) => {
        let row = sensorMetrics.find(element => element.dev_eui === sensor.dev_eui);
        console.log("match:", row);
        
        
        
        
        if (row){
            let percentage = 100 - 100 * (1- (Number(row.value)/4.1))/0.22;
            let percentage_str = percentage.toFixed(1) + ' %';

            if ( (Number(row.value) / 4.1) > 0.1 && (Number(row.value) / 4.1) <= 0.78 ){
                data.push([row.dev_name,  <BatteryAlertIcon key={row.dev_name} style={{ color: 'red' }} />, percentage_str, t.labelActive ])
                return;
            }
            if ( (Number(row.value) / 4.1) > 0.78 && (Number(row.value) / 4.1) <= 0.81){
                data.push([row.dev_name,  <BatteryCharging20Icon key={row.dev_name} style={{ color: 'red' }} />, percentage_str , t.labelActive ])
                return;
            }
            if ( (Number(row.value) / 4.1) > 0.81 && (Number(row.value) / 4.1) <= 0.84){
                data.push([row.dev_name,  <BatteryCharging30Icon key={row.dev_name} style={{ color: 'yellow' }} />, percentage_str , t.labelActive ])
                return;
            }
            if ( (Number(row.value) / 4.1) > 0.84 && (Number(row.value) / 4.1) <= 0.87){
                data.push([row.dev_name,  <BatteryCharging50Icon key={row.dev_name} style={{ color: 'yellow' }} />, percentage_str , t.labelActive ])
                return;
            }
            if ( (Number(row.value) / 4.1) > 0.87 && (Number(row.value) / 4.1) <= 0.9){
                data.push([row.dev_name,  <BatteryCharging60Icon key={row.dev_name} style={{ color: 'orange' }} />, percentage_str , t.labelActive ])
                return;
            }
            if ( (Number(row.value) / 4.1) > 0.9 && (Number(row.value) / 4.1) <= 0.93){
                data.push([row.dev_name,  <BatteryCharging80Icon key={row.dev_name} style={{ color: 'orange' }} />, percentage_str ,  t.labelActive ])
                return;
            }
            if ( (Number(row.value) / 4.1) > 0.93 && (Number(row.value) / 4.1) <= 0.96){
                data.push([row.dev_name,  <BatteryCharging90Icon key={row.dev_name} style={{ color: 'green' }} />, percentage_str ,  t.labelActive ])
                return;
            }
            if ( (Number(row.value) / 4.1) > 0.96){
                data.push([row.dev_name,  <BatteryChargingFullIcon key={row.dev_name} style={{ color: 'green' }} />, percentage_str , t.labelActive ])
                return;
            }
        }else{
            
            //encontrar en dev_eui en plantaciones
            
            data.push([sensor.name, <BatteryUnknownIcon key={sensor.name} style={{ color: "red" }} />, "-" , t.labelInActive ])
        }
    });

    

    return(
        <>
            {(typeof sensorMetrics != 'undefined') ? (
             <MuiThemeProvider key='1' theme={getMuiTheme()}>
                <MUIDataTable
                //title={<h4 >Sensores </h4>}
                data={data}
                columns={columns}
                options={options}
                />
             </MuiThemeProvider>
            ): (
        
                <div className={classes.loading}>
                    <LoadingSpinner />
               </div>
              
            )}
        </>
    )
}



